import React, { useState, useEffect } from 'react';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Lottie from 'lottie-react';
import offerApplied from '../Assets/animations/offerapplied.json';
import offerimg from '../Assets/images/offer.png';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import useCartStore from '../DataRepo/CartStore';
import { getUserDetails } from '../Auth/AuthUtil';
import cgmHeroImg from '../Assets/images/Test Kit/CGM.png';
import cgmMetricsImg from '../Assets/images/Test Kit/CGM metrics.png';
import realTimeIcon from '../Assets/images/Test Kit/Real time.png';
import bulletIcon from '../Assets/images/Test Kit/Bullet point.png';
import cgmGraphImg from '../Assets/images/Test Kit/CGM GRAPH.png';
import freeConsultationIcon from '../Assets/images/Test Kit/Free consultation.png';
import step1Img from '../Assets/images/Test Kit/Step 1 cgm.png';
import step2Img from '../Assets/images/Test Kit/Step 2 CGM.png';
import step3Img from '../Assets/images/Test Kit/Step 3 cgm.png';
import step4Img from '../Assets/images/Test Kit/Step 4 cgm.png';
import Carousel from 'react-bootstrap/Carousel';
import ImageZoom from './ImageZoom';

function CGMTestKit({ Product, onBuyNow, onAddToBag, existingItem, onIncrease, onDecrease }) {
    const price = Product?.other_info?.variants?.[0]?.price ?? Product?.general?.price;
    const orgPrice = Product?.other_info?.variants?.[0]?.compare_at_price ?? Product?.general?.orgprice;
    const userDetails = getUserDetails();
    const { CouponDetails, setCouponDetails, AvailCoupon, CouponErrorDetails, setCouponError } = useCartStore();

    useEffect(() => {
        setCouponDetails(null);
    }, []);

    const isCouponApplied = userDetails && CouponDetails?.couponName?.toUpperCase() === 'CGM10';
    const finalPrice = isCouponApplied ? Math.round(price - (price / 100 * 10)) : price;
    const finalDiscount = orgPrice && finalPrice ? Math.round(((orgPrice - finalPrice) / orgPrice) * 100) : null;

    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const handleApplyCoupon = async () => {
        console.log(userDetails);
        // if (!userDetails) return;
        try {
            await AvailCoupon('CGM10', 'Shop', price);
        } catch (error) {
            console.error(error);
        }
    };

    const whatCGMOffers = [
        { icon: realTimeIcon, title: 'Real-time glucose insights', desc: 'Helps identify patterns and trends in your glucose levels' },
        { icon: cgmMetricsImg, title: 'CGM Metrics and Reports', desc: 'Easy to understand reports with actionable and personalised advice' },
        { icon: realTimeIcon, title: 'Personalised diet recommendations', desc: 'Recommendations to improve your diabetes management' },
        { icon: freeConsultationIcon, title: 'Free Doctor Consultation', desc: 'Schedule a consultation with our doctors to discuss your results' },
    ];

    const benefits = [
        'Detects sugar spikes and drops',
        'Supports weight management and improves metabolism',
        'Helps with diet and food choices',
        'Improves diabetes and insulin control',
    ];

    const outcomes = [
        'Noticeably reduced glucose spikes',
        'Smoother post-meal glucose response',
        'Better energy, fewer cravings and better sleep',
    ];

    const steps = [
        { img: step1Img, desc: 'Kit will be shipped once the order is placed' },
        { img: step2Img, desc: 'AYURAI team contacts the patient to support installation and provides clear guidance' },
        { img: step3Img, desc: '7 days of analysis to identify loads that causes glucose spikes' },
        { img: step4Img, desc: 'Glucose improvement is reviewed over the next 7 days' },
    ];

    return (
        <>
            {/* Error Dialog */}
            <Dialog open={!!CouponErrorDetails} onClose={() => setCouponError(null)}>
                <DialogTitle>Cannot Apply Coupon</DialogTitle>
                <DialogContent>
                    <DialogContentText>{CouponErrorDetails?.message || 'Something went wrong while applying coupon'}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCouponError(null)} style={{ color: '#DA6E0B' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Two-column responsive layout matching existing Product-page */}
            <div className='Product-page-container'>

                {/* ── Left: Image pane ── */}
                <div className='Product-page-img-container'>
                    {/* Alert banner */}
                    <div className='mb-4 w-full' style={{ backgroundColor: 'rgba(140, 235, 140, 0.18)', border: '1px solid #8CEB8C', borderRadius: '10px', padding: '12px 16px', textAlign: 'center' }}>
                        <p className='mb-0 text-sm font-semibold' style={{ color: '#3B362A', fontFamily: "'Poppins', sans-serif", lineHeight: '1.5' }}>
                            Poor Metabolic Health causes <span className='font-medium' style={{ color: '#75623F' }}> Weight Issues, Acne, Irregular periods, Diabetes, Cholesterol, Cardiovascular issues</span>
                        </p>
                    </div>
                    {Product?.general?.images && Product?.general?.images.length > 0 ? (
                        <Carousel
                            activeIndex={selectedImageIndex}
                            onSelect={(index) => setSelectedImageIndex(index)}
                            interval={null}
                            controls={false}
                            indicators={false}
                        >
                            {Product?.general?.images?.map((image, index) => (
                                <Carousel.Item key={index}>
                                    <ImageZoom imageUrl={image?.src}>

                                    </ImageZoom>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : (
                        <ImageZoom imageUrl={Product?.general?.imgurl}>
                        </ImageZoom>
                    )}

                    {Product?.general?.images && Product?.general?.images.length > 0 && (
                        <div className="carousel-indicators-custom">
                            {Product?.general?.images.map((_, index) => (
                                <span
                                    key={index}
                                    className={`indicator-dot ${selectedImageIndex === index ? 'active' : ''}`}
                                    onClick={() => setSelectedImageIndex(index)}
                                ></span>
                            ))}
                        </div>
                    )}


                </div>


                <div className='Product-page-main-container' style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>

                    {/* Product General Info */}
                    <div className='Product-general-info flex flex-col gap-2'>
                        <p
                            className='product-title text-2xl mb-0'
                            style={{ fontFamily: "'Libre Baskerville', serif" }}
                        >
                            {Product?.general?.name || 'Continuous Glucose Monitoring (CGM) system'}
                        </p>

                        <p
                            className='mb-0'
                            style={{
                                color: '#625E55',
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: '14px',
                                lineHeight: '1.6'
                            }}
                        >
                            {Product?.general?.desc || "South Asia's first microbiome-based test for personalised dietary and probiotic recommendations"}
                        </p>

                        <p
                            className='mb-0'
                            style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: '14px',
                                fontWeight: 500
                            }}
                        >
                            QTY : {Product?.general?.qty || '1 Kit'}
                        </p>

                        {/* Price */}
                        <div className='Product-section-price-details flex flex-row items-center gap-4 pt-1'>
                            {orgPrice > 0 && (
                                <p className='mb-0' style={{ fontWeight: 400, color: '#625E55', fontSize: '20px' }}>
                                    <del>₹{orgPrice}</del>
                                </p>
                            )}

                            <p className='mb-0' style={{ fontWeight: 700, color: '#3B362A', fontSize: '26px' }}>
                                ₹{finalPrice}
                            </p>

                            {finalDiscount && (
                                <span
                                    style={{
                                        background: '#E8F5E9',
                                        color: '#2E7D32',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        padding: '3px 10px',
                                        borderRadius: '20px',
                                        fontFamily: "'Poppins', sans-serif"
                                    }}
                                >
                                    {finalDiscount}% Off
                                </span>
                            )}
                        </div>
                    </div>

                    {/* CGM Quote Banner */}
                    <div className='Product-about-info m-2'
                        style={{
                            border: '1px solid #DA6E0B',
                            backgroundColor: '#FFF8F0',
                            borderRadius: '10px',
                            padding: '12px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div style={{ flexShrink: 0, width: '20%' }}>
                            <img src={cgmHeroImg} alt='CGM Quote Icon' style={{ flexShrink: 0 }} />
                        </div>

                        <p
                            className='mb-0 text-lg'
                            style={{
                                fontFamily: "'Libre Baskerville', serif",
                                color: '#3B362A',
                                lineHeight: '1.6'
                            }}
                        >
                            Take Control of your <span style={{ color: '#DA6E0B' }}>METABOLIC HEALTH</span> using a Continuous Glucose Monitor (CGM)
                        </p>
                    </div>

                    {/* Outcome Pills */}
                    <div className='Product-about-info flex flex-col gap-3'>
                        <p
                            className='mb-0'
                            style={{
                                fontFamily: "'Libre Baskerville', serif",
                                fontWeight: 700,
                                fontSize: '17px',
                                background: 'linear-gradient(90deg, #C99B60 59%, #DA6E0B 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}
                        >
                            Clinically proven Glucose spike reduction in <span style={{ color: '#DA6E0B' }}>a week</span>
                        </p>

                        <div className="w-full bg-[#FAFAFA] rounded-xl p-4 mt-4 text-center">
                            <p className="mb-3 text-lg" style={{ fontFamily: "'Poppins', sans-serif", color: '#DA6E0B', fontWeight: 600 }}>
                                AYURAI&apos;s User data
                            </p>

                            <div className="w-full flex justify-center">
                                <div className="w-full max-w-[420px] overflow-hidden rounded-xl">
                                    <img
                                        src={cgmGraphImg}
                                        alt="CGM Metrics"
                                        className="w-full h-auto block object-contain"
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {outcomes.map((item, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', backgroundColor: '#FFF8F0', borderRadius: '10px', padding: '10px 14px' }}>
                                    <img src={bulletIcon} alt='' style={{ width: '20px', height: '20px', flexShrink: 0 }} />
                                    <span style={{ fontSize: '14px', color: '#3B362A', fontFamily: "'Poppins', sans-serif", lineHeight: '1.5' }}>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* What CGM Offers */}
                    <div className='Product-about-info flex flex-col gap-3'>
                        <p className='mb-0' style={{ fontFamily: "'Libre Baskerville', serif", fontWeight: 700, fontSize: '17px', background: 'linear-gradient(90deg, #C99B60 59%, #DA6E0B 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                            What our CGM solution Offers?
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                            {whatCGMOffers.map((f, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                                    <div style={{ width: '52px', height: '52px', backgroundColor: '#FFF3E0', borderRadius: '12px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={f.icon} alt='' style={{ objectFit: 'contain' }} />
                                    </div>
                                    <div style={{ paddingTop: '4px' }}>
                                        <p style={{ fontSize: '14px', fontWeight: 600, color: '#3B362A', marginBottom: '3px', fontFamily: "'Poppins', sans-serif" }}>{f.title}</p>
                                        <p style={{ fontSize: '13px', color: '#625E55', marginBottom: 0, fontFamily: "'Poppins', sans-serif", lineHeight: '1.5' }}>{f.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Benefits */}
                    <div className='Product-about-info' style={{ backgroundColor: '#FAFAFA', borderRadius: '12px', padding: '18px', margin: '0 1rem' }}>
                        <p style={{ fontFamily: "'Libre Baskerville', serif", fontWeight: 600, fontSize: '17px', color: '#3B362A', marginBottom: '12px' }}>Benefits</p>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {benefits.map((b, i) => (
                                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                    <img src={bulletIcon} alt='' style={{ width: '20px', height: '20px', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontSize: '14px', color: '#3B362A', fontFamily: "'Poppins', sans-serif", lineHeight: '1.6' }}>{b}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Free Doctor Consultation */}
                    <div className='Product-other-info flex flex-col gap-4'>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <img src={freeConsultationIcon} alt='' style={{ width: '80px', height: '80px' }} />
                            <p style={{ fontFamily: "'Libre Baskerville', serif", fontWeight: 600, fontSize: '17px', color: '#DA6E0B', marginBottom: 0 }}>
                                Free Doctor Consultation
                            </p>
                        </div>


                        {isCouponApplied ? (
                            <div className="CouponAppliedContainer" style={{ margin: '14px 0' }}>
                                <div className="lottie-background">
                                    <Lottie animationData={offerApplied} />
                                </div>
                                <div className="content">
                                    <img src={offerimg} alt="Offer" />
                                    <div>
                                        <p>{CouponDetails?.couponName?.toUpperCase()} Applied</p>
                                        {
                                            CouponDetails?.couponType === 'percentage' ?
                                                <p>You have saved ₹{((price / 100) * CouponDetails.discount).toFixed(0)} by applying a {CouponDetails.discount}% discount for this order</p> :
                                                <p>You have saved ₹{CouponDetails?.cashRedeem} by applying a coupon for this order</p>
                                        }
                                    </div>
                                </div>
                                <IconButton style={{ alignSelf: "flex-start", justifySelf: "flex-end", marginLeft: 'auto' }} onClick={() => {
                                    setCouponDetails(null)
                                }}>
                                    <HighlightOffIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <div
                                onClick={handleApplyCoupon}
                                style={{
                                    position: 'relative',
                                    overflow: 'hidden',
                                    zIndex: 0,
                                    background: 'linear-gradient(90deg, #FFF8F0 0%, #DDF6CF 100%)',
                                    border: '1px solid #CFE8C4',
                                    borderRadius: '14px',
                                    padding: '18px 20px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    boxShadow: '0 10px 22px rgba(0,0,0,0.14)',
                                    minHeight: '138px',
                                    cursor: userDetails ? 'pointer' : 'default'
                                }}
                            >
                                {/* leaf texture top-right */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-6px',
                                        width: '90px',
                                        height: '90px',
                                        opacity: 0.28,
                                        pointerEvents: 'none',
                                        background: `
                radial-gradient(circle at 20% 30%, #7ED957 0%, #7ED957 18%, transparent 19%),
                radial-gradient(circle at 55% 10%, #9BEA73 0%, #9BEA73 20%, transparent 21%),
                radial-gradient(circle at 80% 40%, #7ED957 0%, #7ED957 18%, transparent 19%),
                radial-gradient(circle at 35% 70%, #9BEA73 0%, #9BEA73 16%, transparent 17%)
            `,
                                        transform: 'rotate(18deg)'
                                    }}
                                />

                                {/* leaf texture bottom-left */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        bottom: '-10px',
                                        left: '-8px',
                                        width: '95px',
                                        height: '60px',
                                        opacity: 0.18,
                                        pointerEvents: 'none',
                                        background: `
                radial-gradient(circle at 15% 75%, #A7D89A 0%, #A7D89A 16%, transparent 17%),
                radial-gradient(circle at 38% 55%, #C6E7BD 0%, #C6E7BD 18%, transparent 19%),
                radial-gradient(circle at 65% 80%, #A7D89A 0%, #A7D89A 16%, transparent 17%)
            `,
                                        transform: 'rotate(-12deg)'
                                    }}
                                />

                                {/* Left side */}
                                <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontFamily: "'Libre Baskerville', serif",
                                            fontSize: '15px',
                                            fontWeight: 700,
                                            color: '#1F1A14',
                                            lineHeight: 1.3
                                        }}
                                    >
                                        Start Your Journey
                                    </p>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            color: '#E56A00',
                                            lineHeight: 1.2
                                        }}
                                    >
                                        10% OFF
                                    </p>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '9px',
                                            fontWeight: 400,
                                            color: '#6E6A62',
                                            lineHeight: 1.4
                                        }}
                                    >
                                        On your first purchase
                                    </p>

                                    {userDetails && (
                                        <div
                                            style={{
                                                marginTop: '12px',
                                                background: '#F1F1F1',
                                                borderRadius: '999px',
                                                padding: '7px 14px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                width: 'fit-content'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontSize: '11px',
                                                    color: '#8B867E',
                                                    fontWeight: 400
                                                }}
                                            >
                                                Tap to Apply
                                            </span>
                                            <span
                                                style={{
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontSize: '12px',
                                                    color: '#6A5744',
                                                    fontWeight: 700
                                                }}
                                            >
                                                CGM10
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* Right side — price */}
                                <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right', minWidth: '110px' }}>
                                    {orgPrice > 0 && (
                                        <>
                                            <p style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: '11px', fontWeight: 500, color: '#6E6A62', lineHeight: 1.2 }}>Our Price</p>
                                            <p style={{ margin: '2px 0 8px 0', fontFamily: "'Libre Baskerville', serif", fontSize: '20px', fontWeight: 700, color: '#888', textDecoration: 'line-through', textDecorationColor: '#DA6E0B', textDecorationThickness: '2px', lineHeight: 1.1 }}>
                                                ₹{price}
                                            </p>
                                        </>
                                    )}

                                    <p style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: '28px', fontWeight: 800, color: '#E56A00', lineHeight: 1.0 }}>₹{Math.round(price - (price / 100 * 10))}</p>
                                    <p style={{ margin: '4px 0 0 0', fontFamily: "'Poppins', sans-serif", fontSize: '12px', fontWeight: 500, color: '#1F1A14', lineHeight: 1.2 }}>You Pay</p>
                                </div>
                            </div>
                        )}

                        {/* Steps */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                            {steps.map((s, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                                    <div style={{ width: '56px', height: '56px', backgroundColor: '#EAF7E8', borderRadius: '12px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={s.img} alt={`Step ${i + 1}`} style={{ width: '38px', height: '38px', objectFit: 'contain' }} />
                                    </div>
                                    <div style={{ paddingTop: '4px' }}>
                                        <p style={{ margin: 0, fontSize: '11px', fontWeight: 700, color: '#DA6E0B', fontFamily: "'Poppins', sans-serif", textTransform: 'uppercase', letterSpacing: '0.8px' }}>Step {i + 1}</p>
                                        <p style={{ margin: '4px 0 0 0', fontSize: '14px', lineHeight: '1.5', color: '#3B362A', fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>{s.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

            </div>

            {/* ── Fixed bottom action bar (same as generic product page) ── */}
            {Product?.general?.onsale && (
                <div className='d-flex justify-content-around align-items-center btm-action-btn'>
                    <div>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px 24px'
                            }}
                            onClick={() => window.open('https://d2vx12jd8iaddd.cloudfront.net/sample+folder/Sample+CGM.pdf', '_blank')}
                        >
                            Sample Report
                        </Button>
                    </div>
                    <div>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                border: '1px solid #DA6E0B',
                                color: '#DA6E0B',
                                boxSizing: 'border-box',
                                backgroundColor: '#FDFDFD',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px 24px'
                            }}
                            onClick={onBuyNow}
                        >
                            Buy now
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
}

export default CGMTestKit;
